import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';

const Box = styled(MuiBox)(({ cursor }) => ({
  ...(cursor && { cursor }),
}));

export default Box;
